export default [
    {
        path: 'atendimento-retroativo',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-atendimento-retroativo' */
            '@/views/pronto-atendimento/atendimento-retroativo/Index'
        ),
        redirect: 'atendimento-retroativo/index',
        children: [
            {
                name: 'pronto-atendimento-atendimento-retroativo-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-retroativo' */
                    '@/views/pronto-atendimento/atendimento-retroativo/List.vue'
                ),
            },
            {
                name: 'pronto-atendimento-atendimento-retroativo-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-atendimento-retroativo' */
                    '@/views/pronto-atendimento/atendimento-retroativo/Form.vue'
                ),
            },
        ],
    },
]